module.exports = __webpack_public_path__ + "img/mb_bg2.393ab0e.webp";